export default __webpack_public_path__ + "assets/no-data-icon.290ebd40.svg";